<template>
    <div class="relative-date-range">
        <pendo-input-number
            class="count-input"
            :value="value.count"
            :min="0"
            :disabled="readOnly"
            :invalid="checkValidRule && !validCount"
            @change="onCountChange" />
        <pendo-multiselect
            class="granularity-select"
            :value="granularity"
            :options="granularityOptions"
            preselect-first
            :disabled="readOnly"
            :append-to-body="false"
            :min-trigger-width="90"
            :min-menu-width="90"
            :invalid="checkValidRule && !validGranularity"
            value-key="granularity"
            @select="onGranularitySelect" />
    </div>
</template>

<script>
import { PendoInputNumber, PendoMultiselect } from '@pendo/components';
import isNumber from 'lodash/isNumber';

export default {
    name: 'RelativeDateRange',
    components: {
        PendoInputNumber,
        PendoMultiselect,
    },
    props: {
        value: {
            type: Object,
            default: () => ({}),
        },
        checkValidRule: {
            type: Boolean,
            default: false,
        },
        readOnly: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['input'],
    data () {
        return {
            granularityOptions: [],
        };
    },
    computed: {
        count () {
            return Number(this.value.count);
        },
        granularity () {
            return this.granularityOptions.find((option) => option.granularity === this.value.granularity);
        },
        validCount () {
            return isNumber(this.count);
        },
        validGranularity () {
            return this.granularity != null && this.granularity !== false;
        },
    },
    created () {
        this.granularityOptions = [
            { granularity: 'days', label: this.$t('segments.timeOptions.days') },
            { granularity: 'weeks', label: this.$t('segments.timeOptions.weeks') },
            { granularity: 'months', label: this.$t('segments.timeOptions.months') },
        ];
        const count = Number.isNaN(this.count) ? 30 : this.count;
        this.onCountChange(count);
    },
    methods: {
        onGranularitySelect (option) {
            this.$emit('input', { field: 'granularity', value: option });
        },
        onCountChange (count) {
            if (count == null) {
                count = 0;
            }

            this.$emit('input', { field: 'count', value: count });
        },
    },
};
</script>

<style scoped lang="less">
.relative-date-range {
    display: grid;
    grid-gap: 8px;
    grid-template-columns: auto 90px;
}
</style>
